<template>
    <div id="menu">
    <router-link to="/">Home</router-link> <span class="padding"> | </span><a class="c-hand" @click="showModal=true">About</a>
    <about
    v-show="showModal"
    @close="closeModal"/>
    </div>
</template>

<script>
import About from './About.vue'

export default {
    components: { About },
    name: "Menu",
    data() { return {
        showModal: false,
        }
    },
    methods:{
      closeModal() {
        this.showModal = false;
        },
    },
}
</script>

<style scoped>
#menu {
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

#menu a {
  font-weight: bold;
  color: #2c3e50;
}

#menu a.router-link-exact-active {
  color: #42b983;
}

.padding {
    padding: 10px;
}

</style>